import React from 'react';

function ToolbarSeparator() {
  return React.createElement("div", {
    className: "slite-editor-toolbar-separator margin-horizontal-smaller background-shade-50 radius-smaller",
    style: {
      width: 2,
      height: 26
    }
  });
}

export default React.memo(ToolbarSeparator);